var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.28577C8.57153 6.07663 10.3624 4.28577 12.5715 4.28577H30.8573L39.4287 12.8572V39.7143C39.4287 41.9235 37.6378 43.7143 35.4287 43.7143H12.5715C10.3624 43.7143 8.57153 41.9235 8.57153 39.7143V8.28577Z",
    fill: "url(#paint0_linear_3069_9418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8573 12.8572L39.4287 12.8572L30.8573 4.28575L30.8573 10.8572C30.8573 11.9617 31.7527 12.8572 32.8573 12.8572Z",
    fill: "#5FCBF2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3052 30.0001V23.2201H12.8572V21.6001H19.6252V23.2201H17.1052V30.0001H15.3052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1038 30.0001L23.4998 26.2321L20.1638 21.6001H22.3718L24.9158 25.3201L28.3118 30.0001H26.1038ZM20.1038 30.0001L23.3078 25.4281L24.6758 26.3761L22.1918 30.0001H20.1038ZM25.1078 26.1001L23.7518 25.1881L26.1038 21.6001H28.1918L25.1078 26.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2427 30.0001V23.2201H28.7947V21.6001H35.5627V23.2201H33.0427V30.0001H31.2427Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9418",
    x1: 24.0001,
    y1: 43.7143,
    x2: 24.0001,
    y2: 4.28577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FCBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12AEE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtIcon);
export default __webpack_public_path__ + "static/media/txt-icon.0e9e35105e069c52d50ece378be9564c.svg";
export { ForwardRef as ReactComponent };